<script>
// import { ref, watch } from "vue";
// import useVuelidate from "@vuelidate/core";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
// import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import axios from 'axios';
import Swal from "sweetalert2";

export default {

    data() {
        return {

            title: "Setting",
            items: [
                {
                    text: "Setting",
                    href: "/",
                },
                {
                    text: "TNC setting",
                    active: true,
                },
            ],
            isLoadingToDisplayData: true,
            Tnclist: [],
            DetailTnc: [],

            loadingDetail:true,
            fullname:'',


            editor: ClassicEditor,
            editorData_cq:"",
            editorData_po:"",
            tnc_id:"",
            content: "<h1>Some initial content</h1>",

            plugins: [
                "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
                "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
                "save table contextmenu directionality emoticons template paste textcolor",
            ],
            toolbar:
                "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print preview media fullpage | forecolor backcolor emoticons",
            options: {
                height: 300,
                style_formats: [
                { title: "Bold text", inline: "b" },
                { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
                { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
                { title: "Example 1", inline: "span", classes: "example1" },
                { title: "Example 2", inline: "span", classes: "example2" },
                { title: "Table styles" },
                { title: "Table row 1", selector: "tr", classes: "tablerow1" },
                ],
            },
        };
    },
    page: {
        title: "Setting",
        meta: [{ name: "Po TNC", content: appConfig.description }],
    },

  

    mounted() {
		this.getList();
	},

  methods: {

        //api to server
        getList() {
            this.isLoadingToDisplayData=true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'setting/tnc/list')
			.then(response => {

				if (response) {
                    this.Tnclist = response.data;
                    this.isLoadingToDisplayData=false;
                } else {
                    this.messageBag = ['No record.'];
                    this.isLoadingToDisplayData=false;
                }
			})
                .catch(error => {
                    this.messageBag = [error.error];
                    this.isLoadingToDisplayData=false;
			});
            
		},

        GetListSetting(country_id){
            this.ButtonSeen=true;
            this.loadingDetail=true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'setting/tnc/list?country_id='+country_id)
            .then(response => {
                if (response) {
                    // console.log('asdadsa');
                    console.log("User Detail",response.data);
                    this.DetailTnc = response.data;
                    this.loadingDetail=false;

                    this.editorData_cq=this.DetailTnc.cq_tnc 
                    this.editorData_po=this.DetailTnc.po_tnc 

                    this.tnc_id=this.DetailTnc.id 


                } else {
                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
            
        },
        
        edittnc(){
            this.ButtonSeen=true;
            this.loadingDetail=true;
            
            const posting_ = { 
                country_id: this.tnc_id,
                cq_tnc: this.editorData_cq,
                po_tnc: this.editorData_po,
            };
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'setting/tnc/edit',posting_)
            .then(response => {
                if (response) { 

                    Swal.fire({
                        title:"Terms and Condition Successfully updated!", 
                        icon:"success",
                    })
                    this.AllMenu = response.data;
                    this.getList();
                } else {
                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },
        

  },
  components: {
        Layout,
        PageHeader,
        // DropZone,
        ckeditor: CKEditor.component
    },

    computed: {
      rowsList() {
        return this.Tnclist.length
      },
    },

};
</script>
<style>
    p { margin:0 }
</style>
<template>

  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                        <h4 class="card-title mb-0 flex-grow-1">Terms and Conditions Setting</h4>
                    </div>

                    <div class="card-body">
                        <div class="live-preview">
                            <div class="row align-items-center g-12">
                                <div class="row">
                                    
                                    <div class="col-lg-6">

                                    </div>
                                    <div class="col-lg-12">
                                        <br><br> 
                                    </div>
                                </div>
                                <br><br>
                                <br>
                                <div class="col-lg-12">
                                    <div class="table-responsive table-card">
                                        <div class="overflow-auto">
                                            <div v-if='isLoadingToDisplayData'>
                                                <div class="spinner-border text-success" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <table class="table align-middle table-nowrap mb-0">

                                                    <thead >
                                                        <tr>
                                                            <td scope="col"><b>No.</b></td>
                                                            <th scope="col">Country</th>
                                                            <th scope="col">CQ TNC</th>
                                                            <th scope="col">PO TNC</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in Tnclist" :key="index" class="content">
                                                            <td valign="top">{{ index+1 }}</td>
                                                            <td valign="top" v-html="item.name"></td>
                                                            <td valign="top" v-html="item.cq_tnc"></td>
                                                            <td valign="top" v-html="item.po_tnc"></td>
                                                            <td valign="top"> 
                                                                <!-- <i @click="GetListSetting(item.id)" class="ri-eye-line" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg"></i>
                                                                &nbsp;  -->
                                                                <i @click="GetListSetting(item.id)" class="bx bx-wrench" data-bs-toggle="modal" data-bs-target=".editRole"></i>
                                                            </td>
                                                        </tr>
                                                    </tbody>

                                                </table>  
                                                <br>
                                                <!-- <b-pagination v-model="currentPageList" :total-rows="rowsList" :per-page="perPageList" aria-controls="mytablea"></b-pagination> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- modal -->
            <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="myLargeModalLabel">Terms and Conditions Detail</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div v-if='loadingDetail'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <!-- <p class="text-muted mb-0">
                                                Country
                                            </p> -->
                                            <h5 class="mb-0">
                                                {{ DetailTnc.name }}
                                            </h5>
                                        </div>
                                        <br><br>
                                        <div class="col-lg-12">
                                            <h4 class="mb-0">
                                                Condition Quotation Terms & Conditions
                                            </h4>
                                            <p class="mb-0" v-html='DetailTnc.cq_tnc'></p>
                                        </div>
                                        <br><br><br>
                                        <div class="col-lg-12">
                                            <h4 class="mb-0" >
                                                Purchase Order Terms & Conditions
                                            </h4>
                                            <p class="mb-0" v-html='DetailTnc.po_tnc'></p>
                                        </div>
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
            
            <div class="modal fade bs-example-modal-lg editRole" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalgridLabel">Edit Terms & Conditions</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                            <div class="modal-body">
                                <div class="row g-3">
                                    <div class="col-lg-6">
                                        <h5 class="mb-0">
                                            {{ DetailTnc.name }}
                                        </h5>
                                    </div>
                                    <div class="col-xxl-12">
                                        <div>
                                            <label for="firstName" class="form-label">Condition Quotation Terms & Conditions <span class="text-danger">*</span></label>
                                            <ckeditor v-model="editorData_cq" :editor="editor"></ckeditor>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="col-xxl-12">
                                        <div>
                                            <label for="firstName" class="form-label">Purchase Order Terms & Conditions <span class="text-danger">*</span></label>
                                            <ckeditor v-model="editorData_po" :editor="editor"></ckeditor>
                                        </div>
                                    </div>
                                    <!--end col-->
                                </div>
                                <!--end row-->
                            </div>
                            <div class="modal-footer">
                                <button type="button" @click="edittnc" class="btn btn-primary">Save changes</button>
                            </div>
                    </div>
                </div>
            </div>
        <!-- end of modal -->
    </Layout>
</template>